import React, { useEffect } from "react";
import ReactModal from "react-modal";
import { Button } from "../Button";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { ReactComponent as CloseSimpleIcon } from "../../../assets/icons/close-simple.svg";

export const Modal = ({
                          isOpen,
                          title,
                          text,
                          actionButtonText,
                          actionButtonCallback,
                          actionButtonPending,
                          actionButtonClassName = "",
                          cancelButtonText,
                          className = "",
                          onClose,
                          children,
                      }) => {
    const isMobile = useIsMobile();

    // Блокируем прокрутку body
    useEffect(() => {
        document.body.style.overflow = isOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            shouldCloseOnOverlayClick={true}
            overlayClassName="
        fixed inset-0 bg-black/40 z-[1000]
        flex items-end justify-center
        lg:items-center
      "
            className={`
        bg-[#fdfdfd] shadow-[0_2px_24px_0_rgba(0,0,0,0.08)]
        w-full max-h-[calc(100vh-40px)]
        overflow-y-auto box-border
        px-5 pb-5 pt-[60px]
        rounded-t-[10px] fixed bottom-0
        lg:relative lg:w-[500px] lg:rounded-[10px]

        ${className}
      `}
        >
            {/* Close icon */}
            <button
                className="
          absolute right-2 top-2 w-11 h-11 flex items-center justify-center
          bg-white rounded-full shadow-[0_2px_24px_0_rgba(0,0,0,0.08)]
        "
                onClick={onClose}
            >
                <CloseSimpleIcon width="70%" height="70%" stroke="#818c99" />
            </button>

            <div>
                {title && <div className="text-[28px] font-medium my-4">{title}</div>}
                {text && <div className="text-[#818c99] my-4">{text}</div>}

                {children}

                {actionButtonText && (
                    <Button
                        pending={actionButtonPending}
                        text={actionButtonText}
                        onClick={actionButtonCallback}
                        fullWidth={isMobile}
                        className={actionButtonClassName}
                    />
                )}

                {cancelButtonText && (
                    <div className="mt-2">
                        <Button text={cancelButtonText} onClick={onClose} variant="secondary" />
                    </div>
                )}
            </div>
        </ReactModal>
    );
};
